export default "__VITE_ASSET__Bba3ME9S__"